import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ToolbarModal = ({
    className,
    component: Component,
    show,
    onModalChange,
    onFilterChange
}) => {
    const [isShow, setShow] = useState(false);
    const overlayEl = useRef(null);

    useEffect(() => {
        setShow(show);
    }, [show]);

    const closeHandler = event => {
        if (overlayEl.current.contains(event.target)) {
            setShow(false);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', closeHandler);
    }, []);

    useEffect(() => {
        onModalChange(isShow);
    }, [isShow]);

    const handleShow = state => {
        if (state === 'close') {
            setShow(false);
        }
        onFilterChange(state);
    };

    return (
        <div className={`${className} ${isShow ? `is-show` : ''}`}>
            <div className="Toolbar__overlay" ref={overlayEl} />
            <Component onModalChange={handleShow} />
        </div>
    );
};

ToolbarModal.propTypes = {
    className: PropTypes.string.isRequired,
    component: PropTypes.any.isRequired,
    show: PropTypes.bool.isRequired,
    onModalChange: PropTypes.func.isRequired,
    onFilterChange: PropTypes.func.isRequired
};

export default styled(ToolbarModal)`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 9999;
    overflow: hidden;
    visibility: hidden;
    transition: visibility 0ms 300ms;

    > div:last-of-type {
        transform: translateY(calc(100% + 70px));
        transition: transform 300ms ease-out;
    }

    .Toolbar__overlay {
        width: 100%;
        height: 100%;
        opacity: 0;
        background: #000;
        transition: opacity 150ms ease-out;
    }

    &.is-show {
        transition: visibility 0ms;

        visibility: visible;

        .Toolbar__overlay {
            opacity: 0.4;
        }

        > div:last-of-type {
            transform: translateY(0%);
        }
    }
`;
